export const initNodeForm = {
  Approver: {
    type: "initiatorAssignee",
    signType: "orSign",
    selfSelectType: "initiator",
    notFindApprover: "transferBoss",
    allowCopier: true,
    operatorSelectRangeIds: [],
    employeeRange: [],
    departmentRange: [],
    roleRange: [],
    supervisorLevel: "1",
    maxSupervisorLevel: "",
    multiDepartmentSignType: "",
    containChildDepartment: false,
    notFoundOtherDepartmentSupervisor: ""
  },
  Finance: {
    type: "role",
    signType: "orSign",
    selfSelectType: "initiator",
    notFindApprover: "transferBoss",
    allowCopier: true,
    operatorSelectRangeIds: [],
    employeeRange: [],
    departmentRange: [],
    roleRange: [],
    supervisorLevel: "1",
    maxSupervisorLevel: "",
    multiDepartmentSignType: "",
    containChildDepartment: false,
    notFoundOtherDepartmentSupervisor: ""
  },
  Cashier: {
    type: "role",
    signType: "orSign",
    selfSelectType: "initiator",
    notFindApprover: "transferBoss",
    allowCopier: true,
    operatorSelectRangeIds: [],
    employeeRange: [],
    departmentRange: [],
    roleRange: [],
    supervisorLevel: "1",
    maxSupervisorLevel: "",
    multiDepartmentSignType: "",
    containChildDepartment: false,
    notFoundOtherDepartmentSupervisor: ""
  },
  Copy: {
    type: "initiatorAssignee", // initiatorAssignee
    employeeRange: [],
    departmentRange: []
  }
};

export const operatorSelectTypes = [
  {
    code: "initiator",
    label: "由制单人指定"
  },
  {
    code: "approver",
    label: "由审批人指定"
  }
];

export const copierOptions = [
  {
    itemName: "预设定人员",
    itemCode: "presetEmployee",
    describe: "直接选择人员或者部门范围，可以多选"
  },
  {
    itemName: "由制单人指定",
    itemCode: "initiatorAssignee",
    describe: "制单时显示选择审批人的界面，可限定可选择人员或者部门的范围"
  }
];

export const selectEmployeeWidgetConfigs = [
  {
    type: "presetEmployee",
    buttonText: "请选择人员",
    label: "选择人员：",
    onlySelectEmployee: true
  },
  {
    type: "initiatorAssignee",
    buttonText: "请选择人员或部门",
    label: "选择范围：",
    onlySelectEmployee: false
  }
];

export const signTypes = [
  {
    code: "sequentialSign",
    label: "依次审批"
  },
  {
    code: "andSign",
    label: "会签"
  },
  {
    code: "orSign",
    label: "或签"
  }
];

export const showSelectSignType = (approvalType, employeeRange) => {
  const whitelist = ["role", "supervisor", "initiatorAssignee"];

  if (whitelist.find(item => item === approvalType)) return true;

  if (employeeRange && employeeRange.length > 1) return true;

  return false;
};

export const signTypesList = (id, approvalType) => {
  const isCashierNode = id.startsWith("Cashier");

  if (isCashierNode) return signTypes.filter(item => item.code == "orSign");

  if (approvalType === "initiatorAssignee") return signTypes;

  return signTypes.filter(item => item.code !== "sequentialSign");
};

const approvalTypeDescribe = {
  presetEmployee: "直接选择人员范围，可以多选。",
  supervisor:
    "制单人的主管，主管的上级主管，可设定向上追述的层级，多部门分摊时，所有部门主管都要同意。",
  role: "请选择一个角色。",
  initiatorAssignee: "制单时显示选择审批人的界面，可限定可选择人员的范围。"
};

export const getApprovalTypeDescribe = approvalType => {
  return approvalTypeDescribe[approvalType] || "";
};

export const approvalTypesCanSelect = (approvalTypes, id) => {
  const toDoTypeCodes = ["employeeInField"];
  const cashierNotSelectCodes = ["supervisor", "initiatorAssignee"];


  approvalTypes = approvalTypes.filter(
    item => !toDoTypeCodes.find(x => item.itemCode === x)
  );

  const isCashierNode = id.startsWith("Cashier");
  if (isCashierNode) {
    approvalTypes = approvalTypes.filter(
      item => !cashierNotSelectCodes.find(x => item.itemCode === x)
    );
  }

  return approvalTypes;
};
